// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"a4f05fc3","851":"126b2828"}[chunkId] + ".chunk.js";
};